var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      query: _vm.query,
      currentUser: _vm.currentUser,
      extraInfoHidden: "",
    },
    scopedSlots: _vm._u([
      {
        key: "emptyListActions",
        fn: function ({ refetchDocuments }) {
          return [
            _c("UploadDocument", {
              staticClass: "flex justify-end pt-3 pb-5",
              attrs: {
                companyId: _vm.companyId,
                groupId: _vm.groupId,
                currentUserId: _vm.currentUser.id,
                buttonSize: "xl",
              },
              on: { documentAdded: refetchDocuments },
            }),
          ]
        },
      },
      {
        key: "actions",
        fn: function ({ refetchDocuments }) {
          return [
            _c("UploadDocument", {
              staticClass: "flex justify-end",
              attrs: {
                companyId: _vm.companyId,
                groupId: _vm.groupId,
                currentUserId: _vm.currentUser.id,
                currentUser: _vm.currentUser,
              },
              on: { documentAdded: refetchDocuments },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }